import {createAction, props} from '@ngrx/store';
import {ProcessInfoDTO} from '../dto/process-info';

export const startProcessInfoSseStream = createAction(
  '[Process Info] Start SSE Stream'
);

export const restartSseStream = createAction(
  '[Process Info] Restart SSE Stream'
);


export const removeInfoErrorMessage = createAction(
  '[Process Info] Remove Error',
  props<{ index: number }>()
);

export const removeAllInfoErrorMessage = createAction(
  '[Process Info] Remove All Error'
);

export const startLoadingProcessInfoSseStream = createAction(
  '[Process Info] Start showing loading'
);

export const stopLoadingProcessInfoSseStream = createAction(
  '[Process Info] Stop showing loading'
);

export const stopSseStreamInfo = createAction(
  '[Process Info] Stop stopSseStreamInfo'
);


export const showLoadingProcessInfoSseStream = createAction(
  '[Process Info] Start showing Infos'
);

export const hideLoadingProcessInfoSseStream = createAction(
  '[Process Info] Stop showing Infos'
);

export const receiveProcessInfoMessage = createAction(
  '[Process Info] Receive SSE Message',
  props<{ message: ProcessInfoDTO }>()
);

export const receiveChatSourcesMessage = createAction(
  '[Process Info] Receive SSE Chat sources Message',
  props<{ message: ProcessInfoDTO }>()
);

export const clearChatSourcesMessage = createAction(
  '[Process Info] Clear SSE Chat sources Message'
);

export const processInfoStreamError = createAction(
  '[Process Info] SSE Stream Error',
  props<{ error: string }>()
);

export const sseStreamCompleted = createAction(
  '[Process Info] SSE Stream Completed'
);

export const checkConnectionStatus = createAction(
  '[Process Info] Check Connection Status'
);
